import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Core.Statement.SetStatus.IRequest;
type Response = Api.Core.Statement.SetStatus.IResponse;
type Headers = Api.Core.Statement.SetStatus.IHeaders;
const url = '/api/DealerManagement/Statement/SetStatus';
export default async function statementSetStatusApi(body: Request): Promise<Api.Res<Response>> {
  const serverResponse = await executeServerApi<Request, Response, Headers>({
    method: HttpMethod.put,
    url,
    body,
    headers: getDefaultHeaders(),
  });
  return serverResponse;
}
